import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-backRefreshModal',
    templateUrl: 'backRefreshModal.component.html',
    standalone: false
})
export class BackRefreshModalComponent implements OnInit {

    modalRef: BsModalRef;
      @ViewChild('cancelPayment', { static: true }) cancelPayment: ModalDirective;
modalConfig = {
  backdrop: 'static'
};
    constructor() { }
    ngOnInit(): void { }

    openModal() {
        this.cancelPayment.show();
    }
}
